import axios from "axios";
import {getField, updateField} from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        fetched: false,
        goods_movement_document_types:[]
    },
    getters:{
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields

    },
    actions: {
        async get({ commit, state, dispatch }, payload){
            updateField(state, {path:'fetched', value:false});
            return await axios.get(this._vm.$apiURL + `/goods_movement_document_types?type=${payload.type}`)
                .then((response) => {
                    updateField(state, {path:'goods_movement_document_types', value:response.data});
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root:true});
                })
                .finally(()=>{
                    updateField(state, {path:'fetched', value:true});
                })
        }
    }
}
